import logo from "./component/other/icon-logo.png";
import "./App.css";

import { Switch, Route, Link } from "react-router-dom";

import Cover from "./component/cover/cover";
import Home from "./component/home/home";
import Interior from "./component/interior/interior";
import Tester from "./component/other/tester";
import Share from "./component/share/Share";

function App() {
  return (
    <div>
      <div className="app-body">
        <Switch>
          <Route exact path="/" component={Cover} />
          <Route exact path="/home" component={Home} />
          <Route exact path="/interior" component={Interior} />
          <Route exact path="/test" component={Tester} />
          <Route exact path="/share/:idBatten/:idFloor" component={Share} />
        </Switch>
      </div>
      <div className="app-header">
        <Link to="/home">
          <img className="app-logo" src={logo} alt="logo" />
        </Link>
      </div>
    </div>
  );
}

export default App;
